import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import Switch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'
import 'react-datepicker/dist/react-datepicker.css'
import { Button, Modal } from 'react-bootstrap'
import GetContentCategories from '../../Services/Queries/GetContentCategories'
import ListPeople from '../../Services/Queries/ListPeople'
import { heightPercentageToDP } from '../../Utils/ResponsiveScreen'

const styles = {
	mandatoryErrorText: {
		fontSize: heightPercentageToDP('2'),
		color: 'red',
	},
}

export default class GeneralOptions extends Component {
	constructor(props) {
		super(props)
		this.state = {
			categories: props.categories ? props.categories : [],
			modalVisible: false,
			peopleModalVisible: false,
			limit: 10,
			nextToken: null,
			spinner: true,
			endReached: false,
			peopleList: [],
			itemTodelete: {},
			searchQuery: '',
			initialLoad: true,
			searchQuery: '',
			selectedPeopleList: [],
			targetAreasList: props.targetAreasList ? props.targetAreasList : []
		}
		this.loadMore = this.loadMore.bind(this)
	}
	closeModal = () => {
		this.setState({ modalVisible: false })
	}
	closePeopleModal = () => {
		this.setState({ peopleModalVisible: false })
	}
	removePerson = (person) => {
		const { selectedPeopleList } = this.state
		const listSelectedPeople = selectedPeopleList.filter(
			(people) => people.peopleValue != person.peopleValue
		)
		this.setState({ selectedPeopleList: listSelectedPeople })
		this.props.handleSelectedPeopleList(listSelectedPeople)
	}
	closePeopleModalAndSendPeople = () => {
		this.setState({ peopleModalVisible: false })
		this.props.handleSelectedPeopleList(this.state.selectedPeopleList)
	}
	loadMore = async () => {
		await this.getNextPeopleLists()
	}
	getPeopleLists = async (searchQuery) => {
		const input = {
			limit: this.state.limit,
		}
		if (searchQuery) {
			input.search = searchQuery
		}
		const data = await ListPeople(input)
		this.setState({
			peopleList: data.items,
			nextToken: data.nextToken,
		})
	}
	getNextPeopleLists = async () => {
		const input = {
			limit: this.state.limit,
			nextToken: this.state.nextToken,
		}
		const data = await ListPeople(input)
		this.setState({
			peopleList: [...this.state.peopleList, ...data.items],
			nextToken: data.nextToken,
		})
	}
	onChangeSearch = (searchQuery) => {
		this.setState({ searchQuery: searchQuery })
		this.getPeopleLists(searchQuery)
	}
	addPeopleToList = (selectedPeople) => {
		const { selectedPeopleList } = this.state
		const selectedPeopleIndex = selectedPeopleList.findIndex(
			(person) => person.peopleValue == selectedPeople.peopleValue
		)
		if (selectedPeopleIndex != -1) {
			selectedPeopleList.splice(selectedPeopleIndex, 1)
		} else {
			const peopleObj = {
				peopleValue: selectedPeople.peopleValue,
				peopleName: selectedPeople.peopleName,

				peopleType: selectedPeople.peopleType,
				peopleCoverImage: selectedPeople.peopleCoverImage.substring(
					selectedPeople.peopleCoverImage.indexOf('public')
				),
				peopleProfileImage: selectedPeople.peopleProfileImage
					? selectedPeople.peopleProfileImage.substring(
						selectedPeople.peopleProfileImage.indexOf('public')
					)
					: '',
			}
			selectedPeopleList.push(peopleObj)
		}
		this.setState({ selectedPeopleList: selectedPeopleList })
		this.props.handleSelectedPeopleList(selectedPeopleList)
	}
	async componentDidMount() {
		this.getPeopleLists()
		this.setState({
			selectedPeopleList: this.props.data.selectedPeopleList
				? this.props.data.selectedPeopleList
				: [],
		})
	}
	async componentDidUpdate(prevProps, prevState) {
		if (prevProps.data.categories != this.props.data.categories) {
			this.setState({ categories: this.props.data.categories })
		}
		if (prevProps.data.targetAreasList != this.props.data.targetAreasList) {
			this.setState({ targetAreasList: this.props.data.targetAreasList })
		}
	}
	renderPeopleList = () => {
		return (
			<div>
				<label for='gsearch'>Search People:</label>
				<input
					type='text'
					onChange={(e) => {
						this.onChangeSearch(e.target.value)
					}}
					value={this.state.searchQuery}
					placeholder='Enter Name'
				></input>
				<div>
					{this.state.peopleList?.map((person, personIndex) => {
						const { selectedPeopleList } = this.state
						const selectedPeopleIndex = selectedPeopleList.findIndex(
							(personItem) => personItem.peopleValue == person.peopleValue
						)
						return (
							<div onChange={() => {
								this.addPeopleToList(person)
							}}
								key={personIndex}>
								<input
									type='checkbox'
									checked={selectedPeopleIndex != -1 ? true : false}
									onChange={() => {
										this.addPeopleToList(person)
									}}
								></input>
								<text onChange={() => {
									this.addPeopleToList(person)
								}}>{person.peopleName}</text>
							</div>
						)
					})}
				</div>
				{this.state.nextToken != null ? (
					<button onClick={this.loadMore} type='button' className='load-more'>
						Load more
					</button>
				) : null}
			</div>
		)
	}
	renderCategories = () => {
		const { data } = this.props
		const { categories } = this.state
		return (
			<div>
				<label for='label'>Choose Categories : </label>
				<div className='row'>
					{data.selectedCategory ? (
						<div>
							<text for='text'>Selected Categories : </text>
							<text>{data.selectedCategory}</text>
						</div>
					) : null}
				</div>
				<div>
					{categories?.map((category, categoryIndex) => (
						<section class='container' key={categoryIndex}>
							{category.options ? (
								<div key={categoryIndex} class='ac'>
									<input
										class='ac-input'
										id={category.heading + category.id + categoryIndex}
										name={category.heading + category.id + categoryIndex}
										type='checkbox'
									/>
									<label class='ac-label' for={category.heading + category.id + categoryIndex}>
										{category.heading}
									</label>
									<article class='ac-text'>
										{category.options &&
											category.options.map((level, levelIndex) => (
												<div key={levelIndex}>
													{level.options ? (
														<div class='ac-sub'>
															<input
																class='ac-input'
																id={level.heading + category.heading + levelIndex}
																name={level.heading + category.heading + levelIndex}
																type='checkbox'
															/>
															<label
																class='ac-label'
																for={level.heading + category.heading + levelIndex}
															>
																{level.heading}
															</label>

															{level.options &&
																level.options.map((sublevel, sublevelIndex) => (
																	<article key={sublevelIndex} class='ac-sub-text'>
																		<p
																			onClick={() =>
																				this.props.setItemSelected(
																					category.addTargetArea, category.addNews,
																					category.heading,
																					level.heading,
																					sublevel.heading,
																					category.wordPressCategoryID,
																					level.wordPressCategoryID,
																					sublevel.wordPressCategoryID
																				)
																			}
																		>
																			{sublevel.heading}
																		</p>
																	</article>
																))}
														</div>
													) : (
														<label
															onClick={() =>
																this.props.setItemSelected(category.addTargetArea, category.addNews,
																	category.heading,
																	level.heading,
																	'',
																	category.wordPressCategoryID,
																	level.wordPressCategoryID,
																	''
																)
															}
															for={level.heading + category.heading + levelIndex}
														>
															{level.heading}
														</label>
													)}
												</div>
											))}
									</article>
								</div>
							) : (
								<label
									onClick={() =>
										this.props.setItemSelected(
											category.addTargetArea, category.addNews,
											category.heading,
											'',
											'',
											category.wordPressCategoryID,
											'',
											''
										)
									}
									for={category.heading + category.id + categoryIndex}
								>
									{category.heading}
								</label>
							)}
						</section>
					))}
				</div>
			</div>
		)
	}

	tagsValidation = () => {
		const tagsAvailble = this.props.data?.tagsArr != undefined && this.props.data.tagsArr.length > 0
		return !tagsAvailble
	}

	categoriesValidation = () => {
		const categoriesAvailable = this.props?.data?.selectedCategory
		return !categoriesAvailable
	}

	renderHashTagsAndSuggestions = () => {
		const { data } = this.props
		return (
			<div>
				<div class='row mb-2'>
					<label for='text'>Choose HashTags </label>
					<input
						type='text'
						onChange={(e) => {
							this.props.handleOnChangeHashTag(e.target.value)
						}}
						disabled={!data.canEditTags}
						value={data.tagValue}
						placeholder='Please Enter HashTags'
					></input>
				</div>
				<div>
					{data.suggestions && data.suggestions.items
						? data.suggestions.items.map((item, index) => (
							<div key={index} onClick={() => this.props.handleSuggestionClick(item)}>
								<text>{item.hashTag}</text>
							</div>
						))
						: null}
				</div>
				<div>
					{data.tags.tagsArray.map((item, count) => (
						<div key={item}>
							<text>{item}</text>
							<text onClick={() => this.props.removeTag(item)}> X </text>
						</div>
					))}
				</div>
				{data.tagsWithGenderArr.length > 0 ? (
					<div>
						{data.genderOptions.map((item, index) => (
							<div key={index} class='justify-content-start'>
								<input
									type='radio'
									checked={data.selectedGenderType == item.genderType}
									onChange={() => {
										this.props.handleGenderTarget(item.genderType)
									}}
								></input>
								<text>{item.genderType}</text>
							</div>
						))}
					</div>
				) : null}
				{/* {this.tagsValidation() ? (
					<text style={styles.mandatoryErrorText}>{'Hashtags empty'}</text>
				) : null} */}
			</div>
		)
	}

	changeTargetAreas = async (targetArea) => {
		const targetAreas = this.state.targetAreasList
		const { selectedTargetAreas } = this.props.data



		let finalTargetAreas = targetArea.parentArea ? selectedTargetAreas : []
		const targetAreaIndex = selectedTargetAreas.findIndex((area) => area.heading == targetArea.heading)
		if (targetAreaIndex != -1) {

			finalTargetAreas = selectedTargetAreas.filter((area) => area.heading != targetArea.heading)
		} else {
			finalTargetAreas.push(targetArea)

		}
		this.props.handleTargetAreas(finalTargetAreas)
	}
	targetAreasValidation = () => {
		const { selectedTargetAreas } = this.props.data
		const targetAreaSelected = selectedTargetAreas && selectedTargetAreas?.length
		return !targetAreaSelected
	}

	sendPnValidation = () => {
		const { sendPushNotification, sendPNWithImage, pnTitle, bigTextTitle } = this.props.data
		const pnTextValidation = sendPNWithImage ? pnTitle != '' : bigTextTitle != ''
		const sendPnValidation = sendPushNotification ? pnTextValidation : true
		return !sendPnValidation
	}

	render() {
		const { data } = this.props
		const { categories, modalVisible, peopleModalVisible } = this.state

		return (
			<div>
				<details>
					<summary>General Options</summary>
					<div class='content'>
						<div class='content'>
							<div class='row'>
								<label for='text'>Choose Content Main Category</label>
							</div>
							<div class='row'>
								<div>
									<input
										value={'news'}
										type='radio'
										checked={data.contentMainCategory == 'news'}
										onChange={() => {
											this.props.handleMainCategory('news')
										}}
									></input>
									<text for='news'>News</text>
								</div>
								<div>
									<input
										value={'infoRegular'}
										type='radio'
										checked={data.contentMainCategory == 'infoRegular'}
										onChange={() => {
											this.props.handleMainCategory('infoRegular')
										}}
									></input>
									<text for='infoRegular'>Info Regular</text>
								</div>
								<div>
									<input
										value={'infoImportant'}
										type='radio'
										checked={data.contentMainCategory == 'infoImportant'}
										onChange={() => {
											this.props.handleMainCategory('infoImportant')
										}}
									></input>
									<text for='infoImportant'>Info Important</text>
								</div>
								<div>
									<input
										value={'infoHighlight'}
										type='radio'
										checked={data.contentMainCategory == 'infoHighlight'}
										onChange={() => {
											this.props.handleMainCategory('infoHighlight')
										}}
									></input>
									<text for='infoHighlight'>Info Highlight</text>
								</div>
							</div>
							<div class='row'>
								<label
									onClick={() => {
										this.setState({ modalVisible: true })
									}}
								>
									Choose Categories
								</label>
								<input
									type='text'
									onClick={() => {
										this.setState({ modalVisible: true })
									}}
									value={data.selectedCategory}
									placeholder='Choose Categories'
								></input>
							</div>
							{this.categoriesValidation() ? (
								<text style={styles.mandatoryErrorText}>{'Category empty'}</text>
							) : null}
							<div class='row'>
								<label
									onClick={() => {
										this.setState({ peopleModalVisible: true })
									}}
								>
									Choose People
								</label>
								<input
									type='text'
									onClick={() => {
										this.setState({ peopleModalVisible: true })
									}}
									value={''}
									placeholder='Choose People'
								></input>
							</div>
							{this.state.selectedPeopleList.map((person, index) => {
								return (
									<div key={index}>
										<div>
											<text>{person.peopleName}</text>
											<text onClick={() => this.removePerson(person)}> X </text>
										</div>
									</div>
								)
							})}
							<Modal show={modalVisible} onHide={() => this.closeModal()}>
								<Modal.Body>{this.renderCategories()}</Modal.Body>
								<Modal.Footer>
									<Button onClick={() => this.closeModal()}>Ok</Button>
								</Modal.Footer>
							</Modal>
							<Modal show={peopleModalVisible} onHide={() => this.closePeopleModal()}>
								<Modal.Body>{this.renderPeopleList()}</Modal.Body>
								<Modal.Footer>
									<Button onClick={() => this.closePeopleModalAndSendPeople()}>Ok</Button>
								</Modal.Footer>
							</Modal>
							{this.renderHashTagsAndSuggestions()}
							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleSendNotification}
									checked={data.sendPushNotification}
									id='sendPushNotification'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='sendPushNotification'>
									Send Push Notification
								</label>
							</div>

							{data.sendPushNotification ? (
								<div>
									<div style={{ marginRight: 10 }}>
										<input
											value={'regularTopic'}
											type='radio'
											checked={data.selectedPnPriority == 'regularTopic'}
											onChange={() => {
												this.props.handlePnPriority('regularTopic')
											}}
										></input>
										<text for={'regularTopic'}>{'Regular Topic'}</text>
									</div>

									<div style={{ marginRight: 10 }}>
										<input
											value={'topStories'}
											type='radio'
											checked={data.selectedPnPriority == 'topStories'}
											onChange={() => {
												this.props.handlePnPriority('topStories')
											}}
										></input>
										<text for={'topStories'}>{'Top Stories'}</text>
									</div>
									<div clss='row'>
										<Grid component='label' container alignItems='center' spacing={1}>
											<Grid item>With Big Text</Grid>

											<Grid item>
												<Switch
													checked={data.sendPNWithImage}
													onChange={() => this.props.handleChangeSendPNWith()}
													value='checkedA'
												/>
											</Grid>
											<Grid item>With Image</Grid>
										</Grid>
									</div>
									<text for='text'>PN Title : </text>
									<div>
										<input
											maxLength={65}
											type='text'
											onChange={(value) => {
												this.props.handlePNTitle(value)
											}}
											value={data.pnTitle ? data.pnTitle.substring(0, 65) : ''}
											placeholder='Please Enter PN Title'
										></input>
									</div>
									{!data.sendPNWithImage ? (
										<div>
											<text for='text'>Big Text : </text>
											<div>
												<textarea
													type='text'
													onChange={(value) => {
														this.props.handlebigTextTitle(value)
													}}
													value={data.bigTextTitle ? data.bigTextTitle : ""}
													placeholder='Please Enter Big Text'
												></textarea>
											</div>
										</div>
									) : (
										<div>
											<text for='text'> PN Description : </text>
											<div>
												<textarea
													maxLength={240}
													type='text'
													onChange={(value) => {
														this.props.handlePNDescription(value)
													}}
													value={data.pnDescription ? data.pnDescription.substring(0, 240) : ''}
													placeholder='Please Enter PN Description'
												></textarea>
											</div>
										</div>
									)}
								</div>
							) : null}
							{this.sendPnValidation() ? (
								<text style={styles.mandatoryErrorText}>{'Please fill pn all fields'}</text>
							) : null}

							<div class='row mb-2'>
								<label for='text'>Choose Scheduled Date And Time </label>

								<DatePicker
									dateFormat={'dd/MM/yyyy HH:mm '}
									minDate={new Date()}
									selected={data.scheduledDate}
									showTimeSelect
									disabled={
										this.props.contentStatus != undefined &&
											this.props.contentStatus != null &&
											this.props.contentStatus == 'm#published'
											? true
											: false
									}
									onChange={(date) => this.props.setStartDate(date)}
								/>
							</div>
							<div class='row mb-2'>
								<label for='text'>Poll Closing Date </label>

								<DatePicker
									dateFormat={'dd/MM/yyyy HH:mm '}
									minDate={new Date()}
									selected={data.pollClosingDate}
									showTimeSelect
									onChange={(date) => this.props.setPollClosingDate(date)}
								/>
							</div>
							<div class='mb-2'>
								<div class='row'>
									<label for='text'>Auto Expire From B.O </label>
								</div>
								<div class='row'>
									{data.autoExpireOptions.map((item, index) => (
										<div key={index} class='col-md-4' style={{ marginRight: 10 }}>
											<input
												disabled={data.stickyPost || data.isInAppMessage}
												value={item}
												type='radio'
												checked={data.selectedAutoExpireDate.value == item.value}
												onChange={() => {
													this.props.handleAutoExpire(item)
												}}
											></input>
											<text for={item.value}>{item.value}</text>
										</div>
									))}
								</div>
							</div>
							<div class='mb-2'>
								<div class='row'>
									<label for='text'>Auto Delete </label>
								</div>
								<div class='row'>
									{data.autoExpireOptions.map((item, index) => (
										<div key={index} class='col-md-4' style={{ marginRight: 10 }}>
											<input
												disabled={data.stickyPost || data.isInAppMessage}
												value={item}
												type='radio'
												checked={data.selectedAutoDeleteDate.value == item.value}
												onChange={() => {
													this.props.handleAutoDelete(item, data.scheduledDate)
												}}
											></input>
											<text for={item.value}>{item.value}</text>
										</div>
									))}
								</div>
							</div>
							<div class='mb-2'>
								<div class='row'>
									<label for='text'>Target Area</label>
								</div>
								<div class='row'>

									{this.state.targetAreasList.map((item, index) => {
										const areaIndex = data.selectedTargetAreas.findIndex((area) => area.heading == item.heading)
										const isAreaSelected = areaIndex != -1 ? true : false
										return (
											< div key={index} style={item.parentArea ? { marginLeft: 15 } : {}} >
												<input
													value={item}
													type='checkbox'
													checked={isAreaSelected}
													onChange={() => {
														this.changeTargetAreas(item)
													}}
												></input>
												<text for={item.heading}>{item.heading}</text>
											</div>
										)
									})}
								</div>
							</div>
							{this.targetAreasValidation() ? (
								<text style={styles.mandatoryErrorText}>{'Please select target areas'}</text>
							) : null}

							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleAllowShare}
									checked={data.allowShare}
									id='allowshare'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='allowshare'>
									Allow Share
								</label>
							</div>

							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleAllowComments}
									checked={data.allowComments}
									id='allowComments'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='allowComments'>
									Allow Comments
								</label>
							</div>
							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleCreateInBoxOffice}
									checked={data.createInBoxOffice}
									disabled={data.stickyPost || data.isInAppMessage}
									id='createInBoxOffice'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='createInBoxOffice'>
									Create In BoxOffice
								</label>
							</div>
							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleChangeStickyPost}
									checked={data.stickyPost}
									id='stickyPost'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='stickyPost'>
									StickyPost
								</label>
							</div>
							{data.stickyPost ? (
								<div>
									<div class='row mb-2'>
										<label for='text'>Sticky End Date And Time</label>
										<DatePicker
											dateFormat={'dd/MM/yyyy HH:mm '}
											minDate={new Date()}
											selected={data.stickyEndDateTime}
											showTimeSelect
											onChange={(date) => this.props.handleChangeStickyEndDateTime(date)}
										/>
									</div>
									<div class='row mb-2'>
										<label for='text'>Position From Top </label>
										<input
											id='positionFromTop'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											onChange={(e) => {
												this.props.handleChangeStickyPositionFromTop(e.target.value)
											}}
											value={data.positionFromTop}
											placeholder='Please Enter Position'
										></input>
										{this.props.hasPositionFromTopError() ? (
											<text for='text' style={{ color: 'red', fontSize: 10 }}>
												Position From Top Cannot Be Empty
											</text>
										) : null}
									</div>
									<div class='mb-2'>
										<div class='row'>
											<label for='text'>Show Sticky</label>
										</div>
										<div class='row'>
											{/* <div>
                        <input
                          value={'Once'}
                          type='radio'
                          checked={data.showSticky == 'Once'}
                          onChange={() => {
                            this.props.handleChangeShowStickyOption('Once')
                          }}
                          disabled={
                            this.props.contentStatus != undefined &&
                            this.props.contentStatus != null &&
                            this.props.contentStatus == 'm#published' &&
                            this.props.isPreviouslyStickyPost != undefined &&
                            this.props.isPreviouslyStickyPost != null &&
                            this.props.isPreviouslyStickyPost
                              ? true
                              : false
                          }
                        ></input>
                        <text for='Once'>Once</text>
                      </div> */}
											<div>
												<input
													value={'Unlimited'}
													type='radio'
													checked={data.showSticky == 'Unlimited'}
													onChange={() => {
														this.props.handleChangeShowStickyOption('Unlimited')
													}}
													disabled={
														this.props.contentStatus != undefined &&
															this.props.contentStatus != null &&
															this.props.contentStatus == 'm#published' &&
															this.props.isPreviouslyStickyPost != undefined &&
															this.props.isPreviouslyStickyPost != null &&
															this.props.isPreviouslyStickyPost
															? true
															: false
													}
												></input>
												<text for='Unlimited'>Unlimited</text>
											</div>
											<div>
												<input
													value={'stickyTargetImpressions'}
													type='radio'
													checked={data.showSticky == 'stickyNoOfTimes'}
													onChange={() => {
														this.props.handleChangeShowStickyOption('stickyNoOfTimes')
													}}
													disabled={
														this.props.contentStatus != undefined &&
															this.props.contentStatus != null &&
															this.props.contentStatus == 'm#published' &&
															this.props.isPreviouslyStickyPost != undefined &&
															this.props.isPreviouslyStickyPost != null &&
															this.props.isPreviouslyStickyPost
															? true
															: false
													}
												></input>
												<text for='stickyNoOfTimes'>Number Of Times</text>
											</div>
										</div>
									</div>
									<div>
										{data.showSticky == 'stickyNoOfTimes' ? (
											<div class='row mb-2'>
												<label for='text'>Number Of Times </label>
												<input
													id='stickyTargetImpressions'
													type='text'
													onKeyPress={(event) => {
														if (!/[0-9]/.test(event.key)) {
															event.preventDefault()
														}
													}}
													disabled={
														this.props.contentStatus != undefined &&
															this.props.contentStatus != null &&
															this.props.contentStatus == 'm#published' &&
															this.props.isPreviouslyStickyPost != undefined &&
															this.props.isPreviouslyStickyPost != null &&
															this.props.isPreviouslyStickyPost
															? true
															: false
													}
													onChange={(e) => {
														this.props.handleChangeStickyNoOfTimes(e.target.value)
													}}
													value={data.stickyTargetImpressions}
													placeholder='Please Enter Number Of Times'
												></input>
												{this.props.hasStickyNumberOfTimesError() ? (
													<text for='text' style={{ color: 'red', fontSize: 10 }}>
														Sticky Number Of Times Cannot Be Empty
													</text>
												) : null}
											</div>
										) : null}
									</div>
									<div>
										<label for='text'>Push this sticky post for</label>
										<input
											id='pushRankUpTo'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											style={{ width: '50px' }}
											disabled={
												this.props.contentStatus != undefined &&
													this.props.contentStatus != null &&
													this.props.contentStatus == 'm#published' &&
													this.props.isPreviouslyStickyPost != undefined &&
													this.props.isPreviouslyStickyPost != null &&
													this.props.isPreviouslyStickyPost
													? true
													: false
											}
											onChange={(e) => {
												this.props.handleChangePushRankUpTo(e.target.value)
											}}
											value={data.pushRankUpTo}
											placeholder='Please Enter Push Rank UpTo'
										></input>
										<label for='text'>Minutes To this Rank</label>
										<input
											style={{ width: '30px' }}
											id='pushRankTo'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											disabled={
												this.props.contentStatus != undefined &&
													this.props.contentStatus != null &&
													this.props.contentStatus == 'm#published' &&
													this.props.isPreviouslyStickyPost != undefined &&
													this.props.isPreviouslyStickyPost != null &&
													this.props.isPreviouslyStickyPost
													? true
													: false
											}
											onChange={(e) => {
												this.props.handleChangePushRankTo(e.target.value)
											}}
											value={data.pushRankTo}
											placeholder='Please Enter Push Rank To'
										></input>
										<div>
											{this.props.hasPushRankToError() ? (
												<text for='text' style={{ color: 'red', fontSize: 10 }}>
													Push Rank To Cannot Be Empty
												</text>
											) : null}
										</div>
										{this.props.hasPushRankUpToError() ? (
											<text for='text' style={{ color: 'red', fontSize: 10 }}>
												Push Rank UpTo Cannot Be Empty
											</text>
										) : null}
									</div>
								</div>
							) : null}
						</div>
					</div>
				</details >
			</div >
		)
	}
}
